module.exports = __webpack_public_path__ + "img/uyumsoft-logo.c5ee09bb.png";